export function getBaseUrl(url) {
  return url ? new URL(url).host : '';
}
